import { all, put, call, fork, take } from "redux-saga/effects";
import * as api from "../../utils/api";
import { saveToken } from "../../utils/api";
import { requestFirebaseNotificationPermission } from "../../utils/firebaseInit";
import { LOGIN_REQUEST, LOGIN_SUCCESS, authActionCreators } from "./actions";

export function* asyncUserLogin({ payload, resolve, reject }) {
  try {
    const response = yield call(api.login, payload);
    if (response.data) {
      yield put(authActionCreators.loginSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* asyncSaveToken({ payload }) {
  try {
    const firebaseToken = yield call(requestFirebaseNotificationPermission);
    if (firebaseToken) {
      yield call(saveToken, { clientId: payload.clientId, token: firebaseToken, accessToken: payload.token });
    }
  } catch (err) {
    console.error(err);
  }
}

export function* watchUserLogin() {
  while (true) {
    const action = yield take(LOGIN_REQUEST);
    yield* asyncUserLogin(action);
  }
}

export function* watchUserLoginSuccess() {
  while (true) {
    const action = yield take(LOGIN_SUCCESS);
    yield* asyncSaveToken(action);
  }
}

export default function* () {
  yield all([fork(watchUserLogin), fork(watchUserLoginSuccess)]);
}
